import { useEffect, useRef, useState } from 'react';
import { DialogActions, Button, styled } from '@mui/material';
import { DownloadButton, IConsent, variables } from '..';
import consentjson from '../../consent.json';
import { downloadConsent, requestIdToBase64 } from '../../request';
import { isEmpty } from 'lodash/fp';

// used in member request

export const RevokeConsent = ({
  handleClose,
}: {
  handleClose: (a: boolean) => void;
}) => {
  const ref = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    ref.current!.scrollIntoView();
  });

  return (
    <div>
      <h3 ref={ref}>{consentjson.revokeConsentTitle}</h3>
      <Wrapper
        dangerouslySetInnerHTML={{ __html: consentjson.revokeConsent }}
      />
      <DialogActions>
        <Button onClick={handleClose.bind(null, false)} variant="contained">
          decline
        </Button>

        <Button
          onClick={handleClose.bind(null, true)}
          variant="contained"
          color="primary"
          autoFocus>
          accept
        </Button>
      </DialogActions>
    </div>
  );
};

export const EmploymentVerificationConsent = ({
  requestId,
  handleClose,
}: {
  requestId: number;
  handleClose: (a: boolean) => void;
}) => {
  const ref = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    ref.current!.scrollIntoView();
  });

  return (
    <div>
      <h1 ref={ref}>{consentjson.employmentVerificationTitle}</h1>
      <Wrapper
        dangerouslySetInnerHTML={{
          __html: consentjson.employmentVerificationConsent,
        }}
      />
      <DialogActions>
        <Button onClick={handleClose.bind(null, false)} variant="contained">
          decline
        </Button>

        <Button
          component="a"
          color="primary"
          variant="contained"
          href={import.meta.env.VITE_EMPLOYMENT_VERIFICATION_URL!.replace(
            '<state>',
            requestIdToBase64({ requestId })
          )}>
          Verify Employment
        </Button>
      </DialogActions>
    </div>
  );
};

export const Consent = ({
  consent: { title, body },
  downloads,
  handleClose,
}: {
  consent: IConsent;
  downloads: string[];
  handleClose: (a: boolean) => void;
}) => {
  const ref = useRef<HTMLHeadingElement>(null);
  useEffect(() => {
    ref.current!.scrollIntoView();
  });

  const [download, setdownload] = useState(false);

  return (
    <div>
      <h1 ref={ref}>{title}</h1>
      <Wrapper dangerouslySetInnerHTML={{ __html: body }} />
      <DialogAction>
        <Button onClick={handleClose.bind(null, false)} variant="contained">
          {isEmpty(title) ? 'exit' : 'decline'}
        </Button>

        {downloadConsent(body) && !isEmpty(title) && (
          <DownloadButton links={downloads} onClick={() => setdownload(true)} />
        )}

        <Button
          disabled={
            downloadConsent(body) && download === false && !isEmpty(title)
          }
          onClick={handleClose.bind(null, true)}
          variant="contained"
          color="primary"
          autoFocus>
          {isEmpty(title)
            ? 'continue'
            : downloadConsent(body)
            ? 'submit'
            : 'accept'}
        </Button>
      </DialogAction>
    </div>
  );
};

const Wrapper = styled('div')(({ theme }) => ({
  ...variables.childrenMarginTop2x,

  '& > h3': { marginLeft: '1rem', fontWeight: 'normal' },
  '& h4': { marginLeft: '2rem', fontWeight: 'normal' },
}));

const DialogAction = styled(DialogActions)(({ theme }) => ({
  '& > *+*': {
    marginLeft: theme.spacing(1),
  },
}));
